export const config = {
    title: 'Электронный каталог',
    catalogs: [
        {
            id: 1,
            image: {
                src: '/catalogs/pdf-1.png',
                width: '80px',
                height: '80px',
            },
            link: '/catalogs/catalog-in-english-2025.pdf',
            title: 'Catalog in English',
        },
        {
            id: 2,
            image: {
                src: '/catalogs/pdf-1.png',
                width: '80px',
                height: '80px',
            },
            link: '/catalogs/provod-barier-2025.pdf',
            title: 'Брошюра Провод Барьерный БЭ-БЭП.00',
        },
        {
            id: 3,
            image: {
                src: '/catalogs/pdf-1.png',
                width: '80px',
                height: '80px',
            },
            link: '/catalogs/cbooklet-elevator-cable-2025.pdf',
            title: 'Буклет лифтовой кабель в круглом и плоском исполнении',
        },
        {
            id: 4,
            image: {
                src: '/catalogs/pdf-1.png',
                width: '80px',
                height: '80px',
            },
            link: '/catalogs/catalog-aviation-defense-2025.pdf',
            title: 'Каталог авиационная и оборонная промышленность',
        },
        {
            id: 5,
            image: {
                src: '/catalogs/pdf-1.png',
                width: '80px',
                height: '80px',
            },
            link: '/catalogs/kcpa-2025.pdf',
            title: 'Каталог КСПА НОВИНКА',
        },
        {
            id: 6,
            image: {
                src: '/catalogs/pdf-1.png',
                width: '80px',
                height: '80px',
            },
            link: '/catalogs/catalog-in-russian-2025.pdf',
            title: 'Перечень выпускаемой продукции',
        },   
        {
            id: 7,
            image: {
                src: '/catalogs/pdf-1.png',
                width: '80px',
                height: '80px',
            },
            link: '/catalogs/catalog-plags-cords-2025.pdf',
            title: 'Перечень удлинители, вилки, шнуры',
        }, 
        {
            id: 8,
            image: {
                src: '/catalogs/pdf-1.png',
                width: '80px',
                height: '80px',
            },
            link: '/catalogs/buklet-provodov-kabeley-podvizhnogo-sostava.pdf',
            title: 'Буклет провода и кабели для подвижного состава',
        },            
    ]
}
